import { BrowserRouter, Routes, Route } from "react-router-dom";
import DesignRequestForm from "./pages/DesignRequestForm";
import Success from "./pages/Success";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DesignRequestForm />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </BrowserRouter>
  );
}
